module.exports = __webpack_public_path__ + "static/media/10.bc27682c.jpg";